import React from "react";
import { Box, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { DCard } from "@ui/components/card/DCard";
export const UserProfileSkeleton = () => {
    return (React.createElement(Box, null,
        React.createElement(DCard, { sx: { mb: 2 } },
            React.createElement(Grid, { container: true, spacing: 2, alignItems: "center" },
                React.createElement(Grid, { size: 6 },
                    React.createElement(Skeleton, { variant: "text", width: "60%", height: 28 }),
                    React.createElement(Box, { sx: { mt: 1 } },
                        React.createElement(Skeleton, { variant: "text", width: "40%", height: 20 }),
                        React.createElement(Skeleton, { variant: "rounded", width: 60, height: 20, sx: { mt: 0.5 } }))),
                React.createElement(Grid, { size: 6 },
                    React.createElement(Skeleton, { variant: "text", width: "30%", height: 20 }),
                    React.createElement(Skeleton, { variant: "text", width: "50%", height: 24, sx: { mt: 0.5 } }),
                    React.createElement(Box, { sx: { display: "flex", gap: 1, mt: 2 } },
                        React.createElement(Skeleton, { variant: "rounded", width: 80, height: 36 }),
                        React.createElement(Skeleton, { variant: "rounded", width: 80, height: 36 }))))),
        React.createElement(Box, { sx: { mb: 2 } },
            React.createElement(Skeleton, { variant: "text", width: 200, height: 32, sx: { mb: 1 } }),
            React.createElement(Skeleton, { variant: "rectangular", height: 400, sx: { borderRadius: 1 } }))));
};
